import { inflect } from 'inflection';

const DURATION_UNITS = {
  Second: 'sec',
  Minute: 'min',
  Hour: 'hour',
  Day: 'day',
  Week: 'wk',
  Month: 'mos',
};

export const getExerciseQuantities = (properties) => {
  const {
    count = 1,
    frequency = 1,
    duration = 30,
    durationUnit = 'Second',
    period = 1,
    periodUnit = 'Day',
  } = properties;
  let durationUnits;
  try {
    durationUnits = inflect(DURATION_UNITS[durationUnit], duration);
  } catch (err) {
    // swallow
  }
  return [
    {
      value: count,
      label: inflect('Rep', count),
    },
    {
      value: duration && durationUnit ? `${duration} ${durationUnits}` : '',
      label: 'Hold',
    },
    {
      value: frequency,
      label: inflect('Set', frequency),
    },
    {
      value: `${period}X`,
      label: `${inflect('Time', period)} Per ${periodUnit}`,
    },
  ];
}
